import React from "react";
import { RenderKilogramo } from "../../../../../../../Utils/renderField/renderReadField";

// Piezas compartidas por los paneles de totales de las tancadas: el resumen de
// kg húmedos por tipo de carga y el total general. Están aparte para que los dos
// paneles se vean igual sin repetir el estilo en cada uno.

export const PanelTotales = ({ children, alineacion = "around" }) => (
    <div
        className={`d-flex justify-content-${alineacion} mt-3 mb-4 py-4 px-3 gap-1rem flex-wrap`}
        style={{ backgroundColor: "#ebebeb", borderRadius: "1rem" }}
    >
        {children}
    </div>
);

// El porcentaje solo se pinta cuando el dato es una parte del total
export const DatoTotal = ({
    etiqueta,
    kg,
    porcentaje,
    anchoMaximoEtiqueta,
}) => (
    <div className="d-flex align-items-center gap-10 justify-content-center flex-wrap">
        <label
            className="mb-0 pl-0 font-weight-500 text-center"
            style={anchoMaximoEtiqueta ? { maxWidth: anchoMaximoEtiqueta } : {}}
        >
            {etiqueta}
        </label>
        <h4 className="text-nowrap mb-0 font-weight-500">
            <RenderKilogramo value={kg || 0} decimals={3} />
            {porcentaje !== undefined && ` (${porcentaje || 0}%)`}
        </h4>
    </div>
);
